/* eslint-disable no-loop-func */
/* eslint-disable jsx-a11y/control-has-associated-label */
/* eslint-disable react/button-has-type */
/* eslint-disable react/no-deprecated */
/* eslint-disable react/jsx-no-bind */
/* eslint-disable prefer-const */
/* eslint-disable no-self-assign */
/* eslint-disable no-param-reassign */
/* eslint-disable no-plusplus */
import React, { useState, useEffect, useRef } from 'react';
import { ChartComponent, SeriesCollectionDirective, SeriesDirective, Inject, Legend, DateTime, Tooltip, DataLabel, Selection, Export, LineSeries, SmaIndicator, Crosshair, Zoom } from '@syncfusion/ej2-react-charts';
import { GridComponent, ColumnsDirective, ColumnDirective, ExcelExport } from '@syncfusion/ej2-react-grids';
import { NumericTextBoxComponent } from '@syncfusion/ej2-react-inputs';
import { DropDownListComponent } from '@syncfusion/ej2-react-dropdowns';
import { ButtonComponent } from '@syncfusion/ej2-react-buttons';
import { ToolbarComponent, ItemsDirective, ItemDirective } from '@syncfusion/ej2-react-navigations';
import axios from 'axios';
import { format, parseISO } from 'date-fns';
import { useSearchParams } from 'react-router-dom';
import { DialogUtility } from '@syncfusion/ej2-react-popups';
import { useStateContext } from '../contexts/ContextProvider';
import { Methods } from '../pages/Methods';
import '../pages/Zackat.css';

export default function Heartbeat({ props }) {
  let chartInstance = useRef(null);
  let intervalId = useRef(null);
  const [timeoutValue, setTimeoutValue] = useState(1000);
  let grid = useRef(null);
  let hrvgrid = useRef(null);
  let hydgrid = useRef(null);
  let oxygrid = useRef(null);
  let rrgrid = useRef(null);
  let bpmgrid = useRef(null);
  let bpgrid = useRef(null);
  let apigrid = useRef(null);
  let blankgrid = useRef(null);
  let hkhrgrid = useRef(null);
  let hkhrvgrid = useRef(null);
  let hkactgrid = useRef(null);
  let actgrid = useRef(null);

  const [addIntervalControl] = useState(false);
  const [charts, setCharts] = useState(JSON.parse(localStorage.getItem('charts')));
  const { REACT_APP_API_ENDPOINT } = process.env;
  // const { REACT_APP_WEATHERAPI_LICENSE_KY } = process.env;
  const { accordionExpanded } = useStateContext();
  const [chartLimit, setChartLimit] = useState(localStorage.getItem('chartLimit') || 14);
  const limitTemplate = () => (
    <div className="e-toolbar-left">
      <input type="text" id="limit" placeholder="Limit number of days" defaultValue={chartLimit} className="custom-toolbar-input" />
      <button type="button" className="e-btn e-success e-outline" onClick={() => { const lim = document.getElementById('limit').value; setChartLimit(lim); localStorage.setItem('chartLimit', Number(lim)); }}>Limit Days</button>
    </div>
  );

  const { REACT_APP_WEATHER_GOOGLE_LICENSE_KY } = process.env;
  // const [apiResponse, setApiResponse] = useState([]);
  const [eventResponse, setEventResponse] = useState([]);
  const [hriEventResponse, setHRIEventResponse] = useState([]);
  const [oxyEventResponse, setOxyEventResponse] = useState([]);
  const [hydEventResponse, setHyEventResponse] = useState([]);
  const [bpmEventResponse, setBpmEventResponse] = useState([]);
  const [actEventResponse, setActEventResponse] = useState([]);
  const [sysEventResponse, setSysEventResponse] = useState([]);
  const [diaEventResponse, setDiaEventResponse] = useState([]);
  const [hkHRVData, setHKHRVData] = useState([]);
  const [hkHRData, setHKHRData] = useState([]);
  const [hkActivity, setHKHRActivity] = useState([]);
  const [sysdiaEventResponse, setSysDiaEventResponse] = useState([]);
  const [rrEventResponse, setRREventResponse] = useState([]);
  const usr = JSON.parse(localStorage.getItem('user'));
  const [minScale, setMinScale] = useState(0);
  const [maxScale, setMaxScale] = useState(200);
  const [intervals, setIntervalScale] = useState(20);
  const [apiLoading, setApiLoading] = useState(false);
  const [searchParams] = useSearchParams();
  const [refresh, setRefresh] = useState(new Date().getTime());
  let associateid = searchParams.get('id');
  let associatename = searchParams.get('name');
  let chartname = `Monaco Charts ${associatename}`;
  const minComponent = () => (
    <div>
      <NumericTextBoxComponent
        value={minScale}
        id="minScale"
        placeholder="Y Minimum Scale"
        title="Y Minimum scale"
        min={0}
        max={400}
        format="N0"
        validateDecimalOnType
        decimals={0}
        floatLabelType="Auto"
        width={120}
      />
    </div>
  );
  const maxComponent = () => (
    <div>
      <NumericTextBoxComponent
        value={maxScale}
        id="maxScale"
        placeholder="Y Maximum Scale"
        title="Y Minimum scale"
        min={0}
        max={400}
        format="N0"
        validateDecimalOnType
        decimals={0}
        floatLabelType="Auto"
        width={120}
      />
    </div>
  );
  const intervalComponent = () => (
    <div>
      <NumericTextBoxComponent
        value={intervals}
        id="intervalScale"
        placeholder="Y Interval Scale"
        title="Y Interval scale"
        min={1}
        max={100}
        format="N0"
        validateDecimalOnType
        decimals={0}
        floatLabelType="Auto"
        width={120}
      />
    </div>
  );
  const setYAxis = () => {
    const n = document.getElementById('minScale').value;
    const x = document.getElementById('maxScale').value;
    const i = document.getElementById('intervalScale').value;
    if (chartInstance && chartInstance.current && chartInstance.current.primaryYAxis) {
      chartInstance.current.primaryYAxis.minimum = Number(n); // Set new minimum
      chartInstance.current.primaryYAxis.maximum = Number(x); // Set new maximum
      chartInstance.current.primaryYAxis.interval = Number(i); // Set new interval
      chartInstance.current.refresh(); // Refresh the chart to apply changes
    }
    setMinScale(n);
    setMaxScale(x);
    setIntervalScale(i);
  };
  const [xintervaltype, setXIntervalType] = useState('Hours');
  const [xintervals, setXInterval] = useState('3');
  const [minDate, setMinDate] = useState(new Date());
  const [maxDate, setMaxDate] = useState(new Date());

  const setXAxis = (e) => {
    const i = document.getElementById('xintervalScale').value;
    setXInterval(i);
    if (chartInstance && chartInstance.current && chartInstance.primaryXAxis) {
      chartInstance.current.primaryXAxis.minimum = minDate; // Set new minimum
      chartInstance.current.primaryXAxis.maximum = maxDate; // Set new maximum
      chartInstance.current.primaryXAxis.interval = Number(i); // Set new interval
      chartInstance.current.primaryXAxis.intervalType = e.value;
      setYAxis();
    }
  };
  const intervalList = [
    { value: 'IntervalType.Years', text: 'Years' },
    { value: 'IntervalType.Months', text: 'Months' },
    { value: 'IntervalType.Days', text: 'Days' },
    { value: 'IntervalType.Hours', text: 'Hours' },
    { value: 'IntervalType.Minutes', text: 'Minutes' },
    { value: 'IntervalType.Seconds', text: 'Seconds' },
  ];
  const xintervalTypeComponent = () => (
    <div>
      <span className="e-icons e-filter-1" /><DropDownListComponent id="ddlmelement" dataSource={intervalList} placeholder="Select an interval for the x-axis" value={xintervaltype} onChange={(e) => { setXIntervalType(e.value); setXAxis(e); }} />
    </div>
  );
  const xintervalComponent = () => (
    <div>
      <NumericTextBoxComponent
        value={xintervals}
        id="xintervalScale"
        placeholder="X Interval Scale"
        title="X Interval scale"
        min={1}
        max={100}
        format="N0"
        validateDecimalOnType
        decimals={0}
        floatLabelType="Auto"
        width={120}
      />
    </div>
  );

  const buttonTemplateInterval = () => (
    <div>
      <ButtonComponent id="yaxis" value="Apply" cssClass="e-small" iconCss="e-icons e-large e-resize" onClick={setXAxis}>Apply</ButtonComponent>
    </div>
  );

  let dialogInstance;
  function dialogClick(f, hdr, content) {
    const ok = null;
    dialogInstance = DialogUtility.confirm({
      title: hdr,
      content,
      okButton: ok,
      cancelButton: { text: 'Cancel', click: () => { dialogInstance.hide(); } },
      showCloseIcon: true,
      closeOnEscape: true,
      isModal: true,
      animationSettings: { effect: 'Zoom' },
    });
  }
  function clickExportHandler() {
    const excelExportProperties = {
      multipleExport: { type: 'NewSheet' }, // Each grid in a new sheet
      fileName: `ExcelExport_Charts_${associatename}_${new Date().toISOString()}.xlsx`,
    };
    if (grid && grid.current) {
      grid.current.excelExport(excelExportProperties, true)
        .then((workbook) => {
          workbook.worksheets[0].name = 'Core Body Temp'; // Rename the first sheet
          return bpmgrid.current.excelExport(excelExportProperties, true, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[1].name = 'Heart Rate'; // Rename the previous sheet
          return hkhrgrid.current.excelExport(excelExportProperties, true, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[2].name = 'W3 Heart Rate'; // Rename the previous sheet
          return hydgrid.current.excelExport(excelExportProperties, true, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[3].name = 'Hydration'; // Rename the previous sheet
          return rrgrid.current.excelExport(excelExportProperties, true, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[4].name = 'Respiration Rate'; // Rename the previous sheet
          return hrvgrid.current.excelExport(excelExportProperties, true, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[5].name = 'HR Variability'; // Rename the previous sheet
          return hkhrvgrid.current.excelExport(excelExportProperties, true, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[6].name = 'W3 HR Variability'; // Rename the previous sheet
          return oxygrid.current.excelExport(excelExportProperties, true, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[7].name = 'Oxygen'; // Rename the previous sheet
          return bpgrid.current.excelExport(excelExportProperties, true, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[8].name = 'BloodPressure'; // Rename the previous sheet
          return actgrid.current.excelExport(excelExportProperties, false, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[9].name = 'Activity'; // Rename the previous sheet
          return hkactgrid.current.excelExport(excelExportProperties, false, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[10].name = 'W3 Activity'; // Rename the previous sheet
          return apigrid.current.excelExport(excelExportProperties, false, workbook); // Next export
        })
        .then((workbook) => {
          workbook.worksheets[11].name = 'API Temperature'; // Rename the LAST sheet
          // Bogus blank sheet just so it writes the name for the last sheet
          //    return blankgrid.current.excelExport(excelExportProperties, false, workbook); // Final export
        });
    }
  }

  const excelExportComplete = (args) => {
    // Access the workbook object from the event arguments
    const workbook = args.gridInstance.excelExportModule.book;
    if (!workbook) {
      return;
    }
    // Assuming you want to rename the last sheet
    const lastSheetIndex = workbook.worksheets.length - 1;
    if (lastSheetIndex >= 0) {
      workbook.worksheets[lastSheetIndex].name = 'API Temperature';
    }
    // Save the modified workbook (this is typically handled automatically if you
    // don't prevent the default action, but you can manually save if needed)
    // args.promise.then(function (args) {
    //     args.blob.then(function (blob) {
    //         saveAs(blob, 'ExportedGrid.xlsx');
    //     });
    // });
  };

  /*
  function origclickExportHandler() {

    if (grid && eventResponse.length > 0) {
      const properties = {
        fileName: `ExcelExport_Charts_${associatename}_Temperature_${new Date().toISOString()}.xlsx`,
      };
      grid.current.excelExport(properties);
    }
    if (bpmgrid && bpmEventResponse.length > 0) {
      const properties = {
        fileName: `ExcelExport_Charts_${associatename}_Heartrate_${new Date().toISOString()}.xlsx`,
      };
      bpmgrid.current.excelExport(properties);
    }
    if (hydgrid && hydEventResponse.length > 0) {
      const properties = {
        fileName: `ExcelExport_Charts_${associatename}_Hydration_${new Date().toISOString()}.xlsx`,
      };
      hydgrid.current.excelExport(properties);
    }
    if (oxygrid && oxyEventResponse.length > 0) {
      const properties = {
        fileName: `ExcelExport_Charts_${associatename}Oxygen${new Date().toISOString()}.xlsx`,
      };
      oxygrid.current.excelExport(properties);
    }
    if (rrgrid && rrEventResponse.length > 0) {
      const properties = {
        fileName: `ExcelExport_Charts_${associatename}Respiratory${new Date().toISOString()}.xlsx`,
      };
      rrgrid.current.excelExport(properties);
    }
  }
  */
  const primaryxAxis = { valueType: 'DateTime', labelIntersectAction: 'Rotate45' };
  const tooltip = {
    enable: true,
    fill: '#78DA89',
    border: {
      width: 2,
      color: '#383838',
    },
  };
  const titlestyle = {
    color: '#383838',
  };

  const [coreTemp, setCoreTemp] = useState(true);
  const [localTemp, setLocalTemp] = useState(true);
  const [heatindex, setHeatIndex] = useState(true);
  const [hydration, setHydration] = useState(true);
  const [oxygen, setOxygen] = useState(true);
  const [hrv, setHRV] = useState(true);
  const [bpm, setBPM] = useState(true);
  const [act, setActivity] = useState(false);
  const [sys, setSystolic] = useState(true);
  const [dia, setDiastolic] = useState(true);
  const [rrate, setRR] = useState(true);
  const [hkbpme, setHKBPM] = useState(true);
  const [hkhrve, setHKHrv] = useState(true);
  const [hkacte, setHKAct] = useState(true);

  const temp = {
    visible: true,
    height: 2,
    width: 2,
    shape: 'Circle',
    color: 'blue',
    dataLabel: { visible: true, format: '{value}°F' },
  };
  const hi = {
    visible: true,
    height: 2,
    width: 2,
    shape: 'Circle',
    color: 'red',
    dataLabel: { visible: true, format: '{value}°F' },
  };
  const vari = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Circle',
    color: 'darkgray',
    dataLabel: { visible: true, format: '{value}ms' },
  };
  const hyd = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Circle',
    color: 'blue',
    dataLabel: { visible: true, format: '{value}%' },
  };
  const oxy = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Circle',
    color: 'lightblue',
    dataLabel: { visible: true, format: '{value}%' },
  };
  const rr = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Circle',
    color: 'lightgreen',
    dataLabel: { visible: true, format: '{value}b/m' },
  };
  const step = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Circle',
    color: 'purple',
    dataLabel: { visible: true, format: '{value}' },
  };
  const systolic = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Circle',
    color: 'cyan',
    dataLabel: { visible: true, format: '{value}' },
  };
  const diastolic = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Circle',
    color: 'orange',
    dataLabel: { visible: true, format: '{value}' },
  };
  const body = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Triangle',
    color: 'orange',
    border: {
      width: 2,
      color: 'orange',
    },
    dataLabel: { visible: true, format: '{value}°F' },
  };
  const hr = {
    visible: true,
    height: 10,
    width: 10,
    shape: 'Circle',
    color: 'darkgreen',
    dataLabel: { visible: true, format: '{value}bpm' },
  };
  function seriesHideShow(e) {
    const { id, index, visible } = e.series;
    let ch = charts;
    if (!charts || !charts[0] || !charts[0].cid) {
      ch = [
        { cid: 'Core', visible: true },
        { cid: 'Temp', visible: true },
        { cid: 'HeatIndex', visible: true },
        { cid: 'Hydration', visible: true },
        { cid: 'Oxygen', visible: true },
        { cid: 'HRV', visible: true },
        { cid: 'BPM', visible: true },
        { cid: 'Activity', visible: true },
        { cid: 'Systolic', visible: true },
        { cid: 'Diastolic', visible: true },
        { cid: 'Respiratory', visible: true },
      ];
    }
    if (visible) {
      const result = ch.find(({ cid }) => cid === id);
      if (result && ch && ch[index]) {
        ch[index].visible = !visible;
        setCharts(ch);
      }
    } else if (!visible) {
      const result = ch.find(({ cid }) => cid === id);
      if (result && ch && ch[index]) {
        ch[index].visible = !visible;
        setCharts(ch);
      }
    }
    localStorage.setItem('charts', JSON.stringify(ch));
  }
  function selectChart(e) {
    if (!e || !chartInstance) {
      return;
    }
    e.forEach((series) => {
      switch (series.cid) {
        case 'Core':
          setCoreTemp(series.visible);
          break;
        case 'Temp':
          setLocalTemp(series.visible);
          break;
        case 'Hydration':
          setHydration(series.visible);
          break;
        case 'HeatIndex':
          setHeatIndex(series.visible);
          break;
        case 'Oxygen':
          setOxygen(series.visible);
          break;
        case 'Respiratory':
          setRR(series.visible);
          break;
        case 'HeartRate':
          setBPM(series.visible);
          break;
        case 'HRV':
          setHRV(series.visible);
          break;
        case 'Systolic':
          setSystolic(series.visible);
          break;
        case 'Diastolic':
          setDiastolic(series.visible);
          break;
        case 'Activity':
          setActivity(series.visible);
          break;
        case 'W3-Activity':
          setHKAct(series.visible);
          break;
        case 'W3-HRV':
          setHKHrv(series.visible);
          break;
        case 'W3-BPM':
          setHKBPM(series.visible);
          break;
        default:
          break;
      }
    });
  }
  let lat = '';
  let lng = '';
  let cDate = new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });
  if (props && props._id) {
    associateid = props._id;
    associatename = props.name;
    if (props.latlng) {
      lat = props.latlng.latitude;
      lng = props.latlng.longitude;
    }
    chartname = `Monaco Charts ${associatename}`;
  } else {
    return <p>No Associate Provided</p>;
  }

  const { loading, data } = Methods('associates', 'GET', associateid) || {};
  const [nextToken, setNextToken] = useState('');
  const [pforecast, setPForecast] = useState([]);
  const [gforecast, setGForecast] = useState([]);
  useEffect(() => {
    if (chartInstance && chartInstance.current) {
      chartInstance.current.refresh();
    }
  }, [accordionExpanded]);
  useEffect(() => {
    const fetchWeather = async () => {
      let gf = pforecast;
      let done = false;
      try {
        // Construct the API call to your weather service
        // (e.g., Google Weather API, OpenWeatherMap, etc.)
        const response = await fetch(`https://weather.googleapis.com/v1/forecast/hours:lookup?key=${REACT_APP_WEATHER_GOOGLE_LICENSE_KY}&location.latitude=${lat}&location.longitude=${lng}&pageSize=24&unitsSystem=IMPERIAL&pageToken=${nextToken}`);

        if (!response.ok) {
          throw new Error('Failed to fetch weather data.');
        }

        const gdata = await response.json();
        if (gdata) {
          // setApiResponse(response.data.forecast.forecastday[0].hour);
          gdata.forecastHours.forEach((f) => {
            f.time = format(parseISO(f.interval.startTime), 'yyyy-MM-dd HH:mm');
            f.temp = f.temperature.degrees;
            f.heatindex = f.heatIndex.degrees;
            gf.push(f);
          });
          if (gdata.nextPageToken) {
            setNextToken(gdata.nextPageToken);
          } else {
            done = true;
          }
          setPForecast(gf);
        }
      } catch (e) {
        console.error('fetchWeather', e);
      } finally {
        if (done === true) {
          setGForecast(gf);
          setApiLoading(true);
        }
      }
    };

    if (lat !== 0 && lng !== 0 && nextToken !== '') {
      fetchWeather();
    }
  }, [nextToken]); // The effect re-runs when the location prop changes

  useEffect(() => {
    const fetchData = async () => {
      await axios({
        url: `${REACT_APP_API_ENDPOINT}/health?associateid=${associateid}&limit=14`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((response) => {
          const hkhrv = [];
          const hkhr = [];
          const hkact = [];
          response.data.forEach((hk) => {
            if (hk.type === 'hrv' && hk.reading && hk.timestamp) {
              hkhrv.push({ hrv: hk.reading, time: `${format(parseISO(hk.timestamp), 'yyyy-MM-dd HH:mm')}` });
            }
            if (hk.type === 'heart_rate' && hk.reading && hk.timestamp) {
              hkhr.push({ bpm: hk.reading, time: `${format(parseISO(hk.timestamp), 'yyyy-MM-dd HH:mm')}` });
            }
            if (hk.type === 'activity' && hk.reading && hk.timestamp) {
              hkact.push({ act: hk.reading, time: `${format(parseISO(hk.timestamp), 'yyyy-MM-dd HH:mm')}` });
            }
          });
          setHKHRVData(hkhrv);
          setHKHRData(hkhr);
          setHKHRActivity(hkact);
        })
        .catch((error) => {
          console.error(error.message);
        });
    };
    fetchData();
  }, [associateid]);
  useEffect(() => {
    const getData = async () => {
      cDate = new Date().toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });
      const today = new Date();
      const fDate = new Date(today.setDate(today.getDate() - 7)).toLocaleDateString('en-CA', { year: 'numeric', month: '2-digit', day: '2-digit' });
      if (associateid === '') {
        return;
      }
      // const weatherApiKey = `${REACT_APP_WEATHERAPI_LICENSE_KY}`;
      if (!apiLoading && lat !== 0 && lng !== 0) {
        let wapi = `https://weather.googleapis.com/v1/forecast/hours:lookup?key=${REACT_APP_WEATHER_GOOGLE_LICENSE_KY}&location.latitude=${lat}&location.longitude=${lng}&pageSize=24&unitsSystem=IMPERIAL`;
        const ghistory = [];
        await axios.get(`${wapi}`)
          .then((response) => {
            if (response && response.data) {
              // setApiResponse(response.data.forecast.forecastday[0].hour);
              response.data.forecastHours.forEach((f) => {
                f.time = format(parseISO(f.interval.startTime), 'yyyy-MM-dd HH:mm');
                f.temp = f.temperature.degrees;
                f.heatindex = f.heatIndex.degrees;
                ghistory.push(f);
              });
              setPForecast(ghistory);
              setNextToken(response.data.nextPageToken);
            }
          })
          .catch((error) => {
            console.error('GOOGLE ERROR', error);
            dialogClick('na', 'GOOGLE Weather error', error);
          });
      }
      // Weather API
      /*
      if (lat !== 0 && lng !== 0) {
        const api = `https://api.weatherapi.com/v1/history.json?q=${lat},${lng}&dt=${fDate}&end_dt=${cDate}&hour_fields=temp_c,wind_mph&aqi=yes&key=${weatherApiKey}`;
        if (!apiLoading) {
          await axios.get(`${api}`)
            .then((response) => {
              if (response && response.data) {
                const history = [];
                response.data.forecast.forecastday.forEach((f) => {
                  f.hour.forEach((h) => {
                    history.push(h);
                  });
                });
                // setApiResponse(response.data.forecast.forecastday[0].hour);
                setApiResponse(history);
              }
            })
            .catch((error) => {
              dialogClick('na', 'API Weather error', error);
            });
        }
      }
        */
      // End Weather API
      setTimeoutValue(30000);
      await axios({
        url: `${REACT_APP_API_ENDPOINT}/events?associateid=${associateid}&limit=${chartLimit}`,
        method: 'get',
        headers: {
          Authorization: `JWTToken ${usr.token}`,
          'Content-Type': 'application/json',
        },
      })
        .then((resp) => {
          if (resp && resp.data) {
            const events = [];
            const hydrationevents = [];
            const oxygenevents = [];
            const hrvevents = [];
            const bpmevents = [];
            const actevents = [];
            const sysevents = [];
            const diaevents = [];
            const sysdiaevents = [];
            const rrevents = [];
            let d = new Date();
            if (resp && resp.data && resp.data.length > 0) {
              resp.data.forEach((element, index) => {
                // Handle the case where HRV has overwritten the HeartRate in Vitals
                if (element.biometrics) {
                  element.biometrics.forEach((b) => {
                    if (b.type && b.type === 'heartrate' && b.reading && b.timestamp) {
                      d = format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm');
                      let cmp = `${fDate} 00:00`;
                      if (d >= cmp) {
                        bpmevents.push({ bpm: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      } else {
                        bpmevents.push({ bpm: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      }
                    }
                    if (b.type && b.type === 'core' && b.reading && b.timestamp) {
                      d = format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm');
                      let cmp = `${fDate} 00:00`;
                      if (d >= cmp) {
                        events.push({ core: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      } else {
                        events.push({ core: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      }
                    }
                    if (b.type && b.type === 'oxygen' && b.reading && b.timestamp) {
                      d = format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm');
                      let cmp = `${fDate} 00:00`;
                      if (d >= cmp) {
                        oxygenevents.push({ oxygen: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      } else {
                        oxygenevents.push({ oxygen: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      }
                    }
                    if (b.type && b.type === 'hydration' && b.reading && b.timestamp) {
                      d = format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm');
                      let cmp = `${fDate} 00:00`;
                      if (d >= cmp) {
                        hydrationevents.push({ hydration: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      } else {
                        hydrationevents.push({ hydration: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      }
                    }
                    if (b.type && b.type === 'respiratory' && b.reading && b.timestamp) {
                      d = format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm');
                      let cmp = `${fDate} 00:00`;
                      if (d >= cmp) {
                        rrevents.push({ respiratory: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      } else {
                        rrevents.push({ respiratory: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      }
                    }
                    if (b.type && b.type === 'activity' && b.reading && b.timestamp) {
                      d = format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm');
                      let cmp = `${fDate} 00:00`;
                      if (d >= cmp) {
                        actevents.push({ act: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      } else {
                        actevents.push({ act: b.reading, time: `${format(parseISO(b.timestamp), 'yyyy-MM-dd HH:mm')}` });
                      }
                    }
                  });
                }
                /*
                if (element.vitals && element.vitals.type && element.vitals.type === 'bp' && element.vitals.reading && element.vitals.timestamp) {
                  d = format(parseISO(element.timestamp), 'yyyy-MM-dd HH:mm');
                  let cmp = `${fDate} 00:00`;
                  const sysdia = element.vitals.reading.split('/');
                  if (d >= cmp) {
                    sysevents.push({ sys: sysdia[0], time: `${format(parseISO(element.vitals.timestamp), 'yyyy-MM-dd HH:mm')}` });
                    diaevents.push({ dia: sysdia[1], time: `${format(parseISO(element.vitals.timestamp), 'yyyy-MM-dd HH:mm')}` });
                  } else {
                    sysevents.push({ sys: sysdia[0], time: `${format(parseISO(element.vitals.timestamp), 'yyyy-MM-dd HH:mm')}` });
                    diaevents.push({ dia: sysdia[1], time: `${format(parseISO(element.vitals.timestamp), 'yyyy-MM-dd HH:mm')}` });
                  }
                  sysdiaevents.push({ sys: sysdia[0], dia: sysdia[1], time: `${format(parseISO(element.vitals.timestamp), 'yyyy-MM-dd HH:mm')}` });
                }
                */
                if (index === 0) {
                  setMaxDate(d);
                } else if (index === resp.data.length - 1) {
                  setMinDate(d);
                }
              });
            }
            setEventResponse(events);
            setHRIEventResponse(hrvevents);
            setOxyEventResponse(oxygenevents);
            setHyEventResponse(hydrationevents);
            setBpmEventResponse(bpmevents);
            setActEventResponse(actevents);
            setSysEventResponse(sysevents);
            setDiaEventResponse(diaevents);
            setSysDiaEventResponse(sysdiaevents);
            setRREventResponse(rrevents);
            /*
            if (args && args.chart && args.chart.series && args.chart.series.length > 0) {
              args.chart.series[0].dataSource = events;
              if (chartInstance && chartInstance.series) {
                chartInstance.series.forEach((plot) => {
                  if (plot.id === 'Hydration') {
                    args.chart.series[plot.index].dataSource = hydrationevents;
                  }
                });
              }
              if (chartInstance && chartInstance.series) {
                chartInstance.series.forEach((plot) => {
                  if (plot.id === 'Oxygen') {
                    args.chart.series[plot.index].dataSource = oxygenevents;
                  }
                });
              }
              if (chartInstance && chartInstance.series) {
                chartInstance.series.forEach((plot) => {
                  if (plot.id === 'Respiratory') {
                    args.chart.series[plot.index].dataSource = rrevents;
                  }
                });
              }
              if (chartInstance && chartInstance.series) {
                chartInstance.series.forEach((plot) => {
                  if (plot.id === 'HRV') {
                    args.chart.series[plot.index].dataSource = hrvevents;
                  }
                });
              }
              if (chartInstance && chartInstance.series) {
                chartInstance.series.forEach((plot) => {
                  if (plot.id === 'BPM') {
                    args.chart.series[plot.index].dataSource = bpmevents;
                  }
                });
              }
              if (chartInstance && chartInstance.series) {
                chartInstance.series.forEach((plot) => {
                  if (plot.id === 'Activity') {
                    args.chart.series[plot.index].dataSource = actevents;
                  }
                });
              }
              if (chartInstance && chartInstance.series) {
                chartInstance.series.forEach((plot) => {
                  if (plot.id === 'Systolic') {
                    args.chart.series[plot.index].dataSource = sysevents;
                  }
                });
              }
              if (chartInstance && chartInstance.series) {
                chartInstance.series.forEach((plot) => {
                  if (plot.id === 'Diastolic') {
                    args.chart.series[plot.index].dataSource = diaevents;
                  }
                });
              }
            }
              */
          }
        })
        .catch((error) => {
          console.error(error);
        });
      setApiLoading(true);
    };
    getData();
  }, [refresh, chartLimit]);

  useEffect(() => {
    intervalId = setInterval(() => { if (chartInstance && chartInstance.current) { chartInstance.current.refresh(); } setRefresh(new Date().getTime()); }, 30000);
    // getData();
    return () => {
      intervalId = clearInterval(intervalId);
      associateid = '';
      chartInstance = null;
      setApiLoading(false);
    };
  }, []);

  function clickHandler() {
    chartInstance.current.exportModule.export('PNG', `${data.associates[0].name}_${cDate}_CoreBodyTemperature`);
  }
  function clickHandlerPDF() {
    const header = {
      content: 'Monaco Charts',
      fontSize: 15,
    };

    const footer = {
      content: '',
      fontSize: 15,
    };
    chartInstance.current.exportModule.export('PDF', `${data.associates[0].name}_${cDate}_CoreBodyTemperature`, 1, [chartInstance.current], null, null, true, header, footer);
  }
  const onToolbarChange = (args) => {
    if (args.target.textContent === 'PNG') {
      clickHandler();
    } else if (args.target.textContent === 'PDF') {
      clickHandlerPDF();
    } else if (args.target.textContent === 'XLS') {
      clickExportHandler();
    }
  };

  function loaded() {
    intervalId = setTimeout(() => {
      if (chartInstance === null) {
        intervalId = clearInterval(intervalId);
        return;
      }
      // selectChart({ value: charts });
      selectChart(charts);
      // getData(args);
      /*
      if (gforecast) {
        chartInstance.current.series.forEach((plot) => {
          if (plot.id === 'HeatIndex') {
            args.chart.series[plot.index].dataSource = gforecast;
          }
        });
        // clearTimeout(intervalId);
        // setTimeoutValue = 1000;
      }
      */
    }, timeoutValue);
  }
  if (loading) {
    return <p>External Data Loading...</p>;
  }
  return (
    <div className="syncfusion-chart">
      <ToolbarComponent id="toolbar" onClick={onToolbarChange}>
        <ItemsDirective>
          {addIntervalControl && <ItemDirective template={minComponent} />}
          {addIntervalControl && <ItemDirective type="Separator" />}
          {addIntervalControl && <ItemDirective template={maxComponent} />}
          {addIntervalControl && <ItemDirective type="Separator" />}
          {addIntervalControl && <ItemDirective template={intervalComponent} />}
          {addIntervalControl && <ItemDirective type="Separator" />}
          {addIntervalControl && <ItemDirective template={xintervalComponent} />}
          {addIntervalControl && <ItemDirective type="Separator" />}
          {addIntervalControl && <ItemDirective template={xintervalTypeComponent} />}
          {addIntervalControl && <ItemDirective type="Separator" />}
          {addIntervalControl && <ItemDirective template={buttonTemplateInterval} />}
          {addIntervalControl && <ItemDirective type="Separator" />}
          <ItemDirective template={limitTemplate} disabled={false} />
          <ItemDirective type="Separator" />
          <ItemDirective text="PNG" prefixIcon="e-print" float="left" />
          <ItemDirective type="Separator" />
          <ItemDirective text="PDF" prefixIcon="e-export-pdf-2" float="left" />
          <ItemDirective type="Separator" />
          <ItemDirective id="myxls" text="XLS" prefixIcon="e-export-excel" float="left" />
          <ItemDirective type="Separator" />
        </ItemsDirective>
      </ToolbarComponent>
      <ChartComponent
        id="charts"
        className="syncfusion-chart"
        loaded={loaded.bind(this)}
        ref={chartInstance}
        enableAutoIntervalOnBothAxis={false}
        primaryXAxis={primaryxAxis}
        primaryYAxis={{
          minimum: minScale,
          maximum: maxScale,
          interval: intervals,
        }}
        tooltip={tooltip}
        titleStyle={titlestyle}
        isMultiSelect
        selectionMode="Point"
        title={chartname}
        legendClick={seriesHideShow}
        zoomSettings={{
          enableSelectionZooming: true, // Enable zooming by selecting an area
          enableMouseWheelZooming: true, // Enable zooming with mouse wheel
          enablePinchZooming: true, // Enable pinch zooming on touch devices
          enablePan: true, // Enable panning after zooming
          toolbarItems: ['Zoom', 'ZoomIn', 'ZoomOut', 'Pan', 'Reset'], // Customize toolbar items
          showToolbar: true, // Show the zooming and panning toolbar
        }}
        legendSettings={{ position: 'Top', title: 'Biometrics' }}
      >
        <Inject services={[LineSeries, Legend, Tooltip, DataLabel, Export, DateTime, SmaIndicator, Crosshair, Selection, Zoom]} />
        <SeriesCollectionDirective className="syncfusion-chart">
          <SeriesDirective className="syncfusion-chart" id="Core" dataSource={eventResponse} visible={coreTemp} xName="time" yName="core" name="Core Body" marker={body} fill="orange" type="Line" />
          {/*
          <SeriesDirective className="syncfusion-chart" id="Temp" dataSource={apiResponse} visible={localTemp} xName="time" yName="temp_f" name="Temperature" marker={temp} fill="black" type="Line" />
          <SeriesDirective className="syncfusion-chart" id="HeatIndex" dataSource={apiResponse} visible={heatindex} xName="time" yName="heatindex_f" name="HeatIndex" marker={hi} fill="red" type="Line" />
          */}
          <SeriesDirective className="syncfusion-chart" id="Temp" dataSource={gforecast} visible={localTemp} xName="time" yName="temp" name="Temperature" marker={temp} fill="black" type="Line" />
          <SeriesDirective className="syncfusion-chart" id="HeatIndex" dataSource={gforecast} visible={heatindex} xName="time" yName="heatindex" name="HeatIndex" marker={hi} fill="red" type="Line" />
          <SeriesDirective id="Hydration" dataSource={hydEventResponse} visible={hydration} xName="time" yName="hydration" name="Hydration" marker={hyd} fill="blue" type="Line" />
          <SeriesDirective id="Oxygen" dataSource={oxyEventResponse} visible={oxygen} xName="time" yName="oxygen" name="Oxygen" marker={oxy} fill="lightblue" type="Line" />
          <SeriesDirective id="HRV" dataSource={hriEventResponse} visible={hrv} xName="time" yName="hrv" name="HRV" marker={vari} fill="darkgray" type="Line" />
          <SeriesDirective id="HKHRV" dataSource={hkHRVData} visible={hkhrve && hkHRVData.length > 0} xName="time" yName="hrv" name="W3-HRV" marker={vari} fill="lightgrey" type="Line" />
          <SeriesDirective id="BPM" dataSource={bpmEventResponse} visible={bpm} xName="time" yName="bpm" name="Heartrate" marker={hr} fill="darkgreen" type="Line" />
          <SeriesDirective id="HKHR" dataSource={hkHRData} visible={hkbpme && hkHRData.length > 0} xName="time" yName="bpm" name="W3-BPM" marker={hr} fill="lightgreen" type="Line" />
          <SeriesDirective id="Activity" dataSource={actEventResponse} visible={act} xName="time" yName="act" name="Activity" marker={step} fill="purple" type="Line" />
          <SeriesDirective id="HKActivity" dataSource={hkActivity} visible={hkacte && hkActivity.length > 0} xName="time" yName="act" name="W3-Activity" marker={step} fill="lavender" type="Line" />
          <SeriesDirective id="Systolic" dataSource={sysEventResponse} visible={sys} xName="time" yName="sys" name="Systolic" marker={systolic} fill="cyan" type="Line" />
          <SeriesDirective id="Diastolic" dataSource={diaEventResponse} visible={dia} xName="time" yName="dia" name="Diastolic" marker={diastolic} fill="orange" type="Line" />
          <SeriesDirective id="Respiratory" dataSource={rrEventResponse} visible={rrate} xName="time" yName="respiratory" name="Respiratory" marker={rr} fill="cyan" type="Line" />
        </SeriesCollectionDirective>
      </ChartComponent>
      {!loading && (
        <div style={{ display: 'none' }}>
          <GridComponent
            dataSource={eventResponse}
            allowExcelExport
            ref={grid}
          >
            <ColumnsDirective>
              <ColumnDirective field="core" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={hriEventResponse}
            allowExcelExport
            ref={hrvgrid}
          >
            <ColumnsDirective>
              <ColumnDirective field="hrv" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={bpmEventResponse}
            allowExcelExport
            ref={bpmgrid}
          >
            <ColumnsDirective>
              <ColumnDirective field="bpm" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={hkHRVData}
            allowExcelExport
            ref={hkhrvgrid}
          >
            <ColumnsDirective>
              <ColumnDirective field="hrv" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={hkHRData}
            allowExcelExport
            ref={hkhrgrid}
          >
            <ColumnsDirective>
              <ColumnDirective field="bpm" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={oxyEventResponse}
            allowExcelExport
            ref={oxygrid}
            // excelExportComplete={excelExportComplete}
          >
            <ColumnsDirective>
              <ColumnDirective field="oxygen" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={rrEventResponse}
            allowExcelExport
            ref={rrgrid}
          >
            <ColumnsDirective>
              <ColumnDirective field="respiratory" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={hydEventResponse}
            allowExcelExport
            ref={hydgrid}
          >
            <ColumnsDirective>
              <ColumnDirective field="hydration" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>

          <GridComponent
            dataSource={actEventResponse}
            allowExcelExport
            ref={actgrid}
          >
            <ColumnsDirective>
              <ColumnDirective field="act" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={hkActivity}
            allowExcelExport
            ref={hkactgrid}
          >
            <ColumnsDirective>
              <ColumnDirective field="act" headerText="Type" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>

          <GridComponent
            dataSource={sysdiaEventResponse}
            allowExcelExport
            ref={bpgrid}
            // excelExportComplete={excelExportComplete}
          >
            <ColumnsDirective>
              <ColumnDirective field="sys" headerText="Systolic" width="100" />
              <ColumnDirective field="dia" headerText="Diastolic" width="100" />
              <ColumnDirective field="time" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={gforecast}
            allowExcelExport
            ref={apigrid}
            excelExportComplete={excelExportComplete}
          >
            <ColumnsDirective>
              <ColumnDirective field="temperature.degrees" headerText="Temperature" width="100" />
              <ColumnDirective field="heatIndex.degrees" headerText="Heat Index" width="100" />
              <ColumnDirective field="interval.startTime" headerText="Time" width="150" />
            </ColumnsDirective>
            <Inject services={[ExcelExport]} />
          </GridComponent>
          <GridComponent
            dataSource={[]}
            allowExcelExport
            ref={blankgrid}
          >
            <Inject services={[ExcelExport]} />
          </GridComponent>

        </div>
      )}
    </div>
  );
}
